import React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "../../../lib/utils";
import { FOCUS_RING } from "./classes";

/**
 * A tooltip that also works on a DISABLED control ("Client has not consented").
 *
 * A disabled `<button>` fires no pointer or focus events, so a tooltip on it never opens.
 * The trigger is therefore a focusable `span` WRAPPING the control: hovering or tabbing
 * onto the span opens the tip, and the reason is also exposed as the span's accessible
 * description (`aria-describedby` through Radix), never as information carried by the
 * disabled styling alone.
 */
export default function CrmTooltip({ content, children, testId, side = "top", disabled = false }) {
  if (disabled || !content) return children;
  return (
    <TooltipPrimitive.Provider delayDuration={150}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.Trigger asChild>
          <span tabIndex={0} className={cn("inline-flex rounded-full", FOCUS_RING)}>{children}</span>
        </TooltipPrimitive.Trigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side={side}
            sideOffset={6}
            data-testid={testId}
            className="z-50 max-w-xs rounded-xl bg-eh-ink px-3 py-2 text-xs text-eh-bg font-body shadow-xl"
          >
            {content}
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
}
